import { Box, Container, Grid, Typography } from '@material-ui/core'
import useStyles from './styles'
import Button from 'baby-ui/foundation/Button'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import { babylistUrl, healthAdvisoryBoardPath } from 'lib/urls'

const LOGOS = {
  MEDELA: '//images.babylist.com/image/upload/v1669755481/DME/medela-logo.jpg',
  SPECTRA:
    '//images.babylist.com/image/upload/v1669755482/DME/Spectra-Logo-2022.webp',
  ELVIE: '//images.babylist.com/image/upload/v1669755484/DME/elvie_logo.svg',
  DR_BROWNS:
    '//images.babylist.com/image/upload/v1669755485/DME/willow-logo.png',
  WILLOW:
    '//images.babylist.com/image/upload/v1669755486/DME/DB-logo-Registered-H.jpg',
  LANSINOH:
    '//images.babylist.com/image/upload/v1669755486/DME/lansinoh-logo.png',
}

export default function InsurancePartnerView() {
  const classes = useStyles()

  return (
    <>
      <img
        className={classes.heroImage}
        src={
          '//images.babylist.com/image/upload/v1669753285/DME/NY-Cribs-Pump-70.jpg'
        }
      />
      <Box component={Container} py={8} textAlign="center">
        <Typography
          className={classes.sectionHeading}
          component="h2"
          variant="h4"
        >
          Who We Are
        </Typography>
        <Typography align="left" gutterBottom>
          Babylist is the leading platform for women during pregnancy, helping
          1.25 million parents-to-be annually. The Babylist expert-led guidance
          recommends best-in-class products, provides health and wellness
          content, and facilitates purchase decisions for families at the start
          of their parenting journey. As a leading channel of breast pumps with
          four years experience as a Durable Medical Equipment Supplier for
          insurance breast pumps, we are excited to expand our mission to serve
          how new parents receive their medical supplies. Babylist desires to
          make pregnancy more affordable for moms and complement your health
          plan's mission to provide the best experience for your pregnant
          members.
        </Typography>
      </Box>

      <div className={classes.gradientSection}>
        <Button
          className={classes.clearButton}
          href={'mailto:health_contracts@babylist.com'}
        >
          <MailOutlineIcon />
          &nbsp;Contact Us
        </Button>
      </div>

      <Box component={Container} py={8} textAlign="center">
        <Typography
          className={classes.sectionHeading}
          component="h2"
          variant="h4"
        >
          Key Benefits
        </Typography>
        <Grid container direction="row" spacing={6}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6">
              Annual New Moms Signing Up on Babylist{' '}
              <Typography className={classes.numberHighlight} variant="h3">
                1.25M
              </Typography>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6">
              Subscribers for Pregnancy and Parenting Resources{' '}
              <Typography className={classes.numberHighlight} variant="h3">
                2.2M
              </Typography>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6">
              Average Gestational Age for New Mom Signups{' '}
              <Typography className={classes.numberHighlight} variant="h3">
                20 Weeks
              </Typography>
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box component={Container} py={8} textAlign="center">
        <Typography
          className={classes.sectionHeading}
          component="h2"
          variant="h4"
        >
          Wide Selection of Pumps
        </Typography>
        <Grid
          container
          direction="row"
          spacing={4}
          style={{ alignItems: 'center' }}
        >
          <Grid item xs={12} sm={4}>
            <img className={classes.logo} src={LOGOS.MEDELA} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <img className={classes.logo} src={LOGOS.SPECTRA} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <img className={classes.logo} src={LOGOS.ELVIE} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <img className={classes.logo} src={LOGOS.DR_BROWNS} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <img className={classes.logo} src={LOGOS.WILLOW} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <img className={classes.logo} src={LOGOS.LANSINOH} />
          </Grid>
        </Grid>
        <Typography>...and more</Typography>
      </Box>

      <Box component={Container} pt={6} pb={20} textAlign="center">
        <Typography
          className={classes.sectionHeading}
          component="h2"
          variant="h4"
        >
          Babylist Health Advisory Board
        </Typography>
        <Typography>
          The Babylist Health Advisory Board is made up of renowned doctors,
          researchers and other health professionals from the fields of
          obstetrics and gynecology, psychology, pediatrics, nutrition, and
          more. We collaborate with the Health Advisory Board, drawing on their
          knowledge and expertise to inform content decisions, host
          community-focused social events and more to help our community. To
          learn more about each of them, visit the{' '}
          <a href={babylistUrl(healthAdvisoryBoardPath)}>
            Babylist Health Advisory Board
          </a>{' '}
          page.
        </Typography>
      </Box>
    </>
  )
}
